import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from '../HomePage'
import ErrorPage from '../ErrorPage/ErrorPage';
import ContactPage from '../ContactPage/ContactPage';
import RequestForm from '../RequestForm';
import ProductList from '../Product/listing';
import ProductDetail from '../Product/details';
import AdminDashboard from '../AdminDashboard';
import LoginPage from '../LoginPage';


const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Homepage />} />
          <Route path='home' element={<Homepage />} />
          <Route path='products' element={<ProductList />} />
          <Route path='products/:id' element={<ProductDetail />} />
          <Route path='request' element={<RequestForm />} />
          <Route path='*' element={<ErrorPage />} />
          <Route path='contact' element={<ContactPage />} />
          <Route path='admin-dashboard-secret' element={<AdminDashboard />} />
          <Route path='login' element={<LoginPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default AllRoute;
